import { Error } from '../Error'
import { Width } from '../Width'
import { Controller } from 'react-hook-form'

import { Label } from '@/components/ui/label'
import {
  Select as SelectComponent,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import type { SelectField } from '@payloadcms/plugin-form-builder/types'
import type { Control, FieldErrorsImpl, FieldValues, RegisterOptions } from 'react-hook-form'

export const Select: React.FC<
  SelectField & {
    control: Control
    errors: Partial<FieldErrorsImpl>
    validation?: RegisterOptions<FieldValues>
  }
> = ({
  name,
  control,
  errors,
  label,
  options,
  required,
  defaultValue,
  placeholder,
  validation,
}) => {
  const validationRules: RegisterOptions<FieldValues> = {
    required: required ? (required === true ? 'This field is required' : required) : false,
    ...validation,
  }

  return (
    <Width>
      <Label htmlFor={name}>
        {label}
        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field }) => {
          const { onChange, onBlur, value, ref } = field
          const controlledValue = options.find((t) => t.value === value)

          return (
            <SelectComponent onValueChange={(val) => onChange(val)} value={controlledValue?.value}>
              <SelectTrigger className="w-full" id={name} onBlur={onBlur} ref={ref}>
                <SelectValue placeholder={placeholder || label} />
              </SelectTrigger>
              <SelectContent>
                {options.map(({ label, value }) => {
                  return (
                    <SelectItem key={value} value={value}>
                      {label}
                    </SelectItem>
                  )
                })}
              </SelectContent>
            </SelectComponent>
          )
        }}
        rules={validationRules}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
